let name, email, phone, consent, date;
let otpData;

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function checkCookie(name) {
    var cookieValue = getCookie(name);
    if (cookieValue) {
        return true;
    } else {
        return false;
    }
}

function cookieAlreadyPresent() {
    const contactForm = document.querySelector("#contactForm");
    const otpForm = document.querySelector("#contact-form-otp");
    const contactThankyou = document.querySelector(".contact-thankyou");
    contactForm.style.display = "none";
    otpForm.style.display = "none";
    contactThankyou.style.display = "block";
}

if (checkCookie("health-and-glow-freebie")) {
    cookieAlreadyPresent();
}


document.getElementById('contactForm').addEventListener('submit', function(event) {
    event.preventDefault();
    debugger

    name = document.getElementById('contact_name').value;
    email = document.getElementById('contact_email').value;
    phone = document.getElementById('contact_phone').value;
    consent = document.getElementById('checkbox-1').checked ? 'yes' : 'no';
    date = new Date().toISOString().split('T')[0];

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      const emailErrorMessage = document.querySelector('#error-email');
      emailErrorMessage.innerHTML = 'Please enter a valid email address';
      return;
    }

    if (phone.length != 10){
      const phoneErrorMessage = document.querySelector('#error-no');
      phoneErrorMessage.innerHTML = 'Please enter a 10 digit mobile number';
      return;
    }
  
    const data = {
      phone: `91${phone}`,
      email : email
    };

    otpData = {
      name : name,
      email : email,
      phone : `91${phone}`,
      date : date,
      consent : consent,
      otp : ""     
    }

    fetch('https://hul-health-glow-otp.marmeto.com/api/send/otp', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      if (data.success == false) {
        setStatusMessage(data.message, 'red');
        return
      }
      console.log('Success:', data);
      document.getElementById('contactForm').reset();
      setStatusMessage('Thank you! We have successfully received your submission.', 'green');
      hideContactForm();
    })
    .catch((error) => {
      console.error('Error:', error);
      setStatusMessage('There was a problem submitting your form.', 'red');
    });
  });

  document.getElementById('contact-form-otp').addEventListener('submit', function(event) {
    event.preventDefault();
    const otp = document.getElementById('otp_phone').value;
    otpData.otp = otp;

        // Send POST request
    fetch('https://hul-health-glow-otp.marmeto.com/api/save/informations', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(otpData)
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            console.log('Otp Verified and Data Saved Successfully:', data);
            // Handle success response
            // Convert otpData to string format and do something with it
            const otpDataString = JSON.stringify(data);
            const bannerImage = document.querySelector('.banner-image');
            bannerImage.style.display = 'none';
            // Example action: display success message to user
            hideOtpForm();         
            setCookie("health-and-glow-freebie", "true", 30);
            Moengage.track_event("health_and_glow", otpData);
            Moengage.add_unique_user_id(email);
            Moengage.add_mobile(phone);
            Moengage.add_email(email);
            
            
        } else {
            console.error('Error:', data.error);
            // Handle failure response
            // alert('Error: ' + data.error);
            otpErrorMessage(data.error);
        }
    })
    .catch(error => {
        console.error('Error:', error);
        // Handle network or other errors
        otpErrorMessage(error);
    });

  });

  function hideContactForm() {
    const contactForm = document.querySelector('#contactForm');
    const otpForm = document.querySelector('#contact-form-otp');
    contactForm.style.display = 'none';
    otpForm.style.display = 'block'; 
  }
  
  function hideOtpForm() {
    const otpForm = document.querySelector('#contact-form-otp');
    const thankYouPage = document.querySelector('.contact-thankyou');
    otpForm.style.display = 'none';
    thankYouPage.style.display = 'block';
  }

  function otpErrorMessage(message) {
    const otpErrorMessage = document.querySelector('#error-otp');
    otpErrorMessage.innerHTML = message;
  }



  function setStatusMessage(message, color) {
    const statusMsg = document.querySelector('.form-status-msg');
    
    statusMsg.textContent = message;
    statusMsg.style.color = color;
  }

  const inputs = document.querySelectorAll('#contactForm input');
  inputs.forEach(input => {
    input.addEventListener('input', () => {
      const statusMsg = document.querySelector('.form-status-msg');
      statusMsg.textContent = '';
    });
  });